import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import SelectionBox from './SelectionBox';
import CustomPanelGroup from './CustomPanelGroup';
import CheckboxGroup from './CheckboxGroup';
import Slider from 'react-slick';
import ActivationStepDetails from '../common/ActivationStepDetails';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

class ManageServices extends Component {
  constructor() {
    super();
    this.toggleNotification = this.toggleNotification.bind(this);
    this.tabBarClick = this.tabBarClick.bind(this);
    this.tabClickSwitch = this.tabClickSwitch.bind(this);
    this.state = {
      searchMobile: false,
      showModal: true,
      isLoaded: false,
      panelOpen: false,
      notificationVisible: false,
      selectedTab: 'car-wash',
      showSidebar: false,
      serviceInfoList: [],
      repairInfoList: []
    };
  }

  componentWillMount() {
    this.props.actions.hideToastMessage();
    let garage_id = JSON.parse(localStorage.getItem('garage_id'));
    if (garage_id) {
      this.props.actions.getGarageProfile(garage_id);
    }
    this.props.actions.getServices(true);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vendorProfileReducer && nextProps.vendorProfileReducer.isManageServicesLoaded) {
      this.setState({ isLoaded: nextProps.vendorProfileReducer.isManageServicesLoaded });
    }
    if(nextProps.vendorProfileReducer.garageServiceTypes){
      this.updateServiceType();
    }
    if(nextProps.vendorProfileReducer.garageRepairTypes){
      this.updateRepairType();
    }
  }

  updateRepairType(){
    const {vendorProfileReducer } =this.props;
    let garageRepair = vendorProfileReducer.garageRepairTypes;
    if(garageRepair && this.state.repairInfoList.length === 0){
      garageRepair.map((repair)=> {
        repair.paidInspection = (repair.hasOwnProperty('inspectionamount') && repair.inspectionamount > 0)? true: false;
        repair.inspectionamount = repair.hasOwnProperty('inspectionamount')? repair.inspectionamount : 0;
        repair.isinspectionrequired = repair.hasOwnProperty('isinspectionrequired') ? repair.isinspectionrequired : false;
      });
      this.setState({repairInfoList:garageRepair});
    }
  }
  updateServiceType() {
    const {vendorProfileReducer } =this.props;
    let garageServices = vendorProfileReducer.garageServiceTypes;
    if(garageServices && this.state.serviceInfoList.length === 0){
      garageServices.map((service)=> {
        service.paidInspection = (service.hasOwnProperty('inspectionamount') && service.inspectionamount > 0)? true: false;
        service.inspectionamount = service.hasOwnProperty('inspectionamount')? service.inspectionamount : 0;
        service.isinspectionrequired = service.hasOwnProperty('isinspectionrequired') ? service.isinspectionrequired : false;
      });
      this.setState({serviceInfoList:garageServices});
    }

  }

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }

  handleBtnClick() {
    if (this.state.selectedTab == 'car-wash') {
      this.setState({ selectedTab: 'car-service' });
    } else if (this.state.selectedTab == 'car-service') {
      this.setState({ selectedTab: 'car-repair' });
    } else if (this.state.selectedTab == 'car-repair') {
      this.setState({ selectedTab: 'emergency' });
    } else if (this.state.selectedTab == 'emergency') {
      this.setState({ selectedTab: 'manufactures' });
    }
  }

  tabBarClick(tabName) {
    if (this.state.selectedTab == 'car-wash') {
      this.refs && this.refs.carwash && this.refs.carwash.handleTabSwitch(tabName);
    } else if (this.state.selectedTab == 'car-service') {
      this.refs && this.refs.carservice && this.refs.carservice.handleTabSwitch(tabName);
    } else if (this.state.selectedTab == 'car-repair') {
      this.refs && this.refs.carrepair && this.refs.carrepair.handleTabSwitch(tabName);
    } else if (this.state.selectedTab == 'emergency') {
      this.refs && this.refs.emergency && this.refs.emergency.handleTabSwitch(tabName);
    } else if (this.state.selectedTab == 'manufactures') {
      this.refs && this.refs.manufactures && this.refs.manufactures.handleTabSwitch(tabName);
    }
  }

  tabClickSwitch(tabName) {
    this.setState({ selectedTab: tabName });
  }

  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }

  render() {
    const { vendorProfileReducer, commonReducer, actions, router } = this.props;
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    const settings = {
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 3.5
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    };
    return (
      <div>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={commonReducer}
          actions={actions}
          notificationCount={2}
          profileName="Derrick Frank"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper manage-profile">
          {/*Sidebar*/}
          {authData &&
            authData.isBusinessRegistered &&
            authData.isGarageProfileCompleted &&
            authData.isGarageServiceSelected &&
            <Sidebar
              showSidebar={this.state.showSidebar}
              router={router}
              actions={actions}
              commonReducer={commonReducer}
              authReducer={this.props.authReducer}
            />}
          <div
            className={
              authData &&
                authData.isBusinessRegistered &&
                authData.isGarageProfileCompleted &&
                authData.isGarageServiceSelected
                ? 'container-fluid main-container'
                : 'container-fluid main-container con-align'
            }
          >
            <div className="col-md-12">
              <div className="overview-heading"><h5>Manage Services</h5></div>
              {authData &&
                authData.isBusinessRegistered &&
                authData.isGarageProfileCompleted &&
                !authData.isGarageServiceSelected &&
                <ActivationStepDetails
                  isGarageProfileCompleted={authData.isGarageProfileCompleted}
                  isGarageServiceSelected={authData.isGarageServiceSelected}
                />}

              <div className="s-managed-service content-view">
                <div className="nav-selector nav-selector-desktop">
                  <li
                    className={this.state.selectedTab == 'car-wash' ? ' active' : ''}
                    onClick={() => this.tabBarClick('car-wash')}
                  >
                    <a>Car Wash</a>
                  </li>
                  <li
                    className={this.state.selectedTab == 'car-service' ? ' active' : ''}
                    onClick={() => this.tabBarClick('car-service')}
                  >
                    <a>Car service</a>
                  </li>
                  <li
                    className={this.state.selectedTab == 'car-repair' ? ' active' : ''}
                    onClick={() => this.tabBarClick('car-repair')}
                  >
                    <a>car repair</a>
                  </li>
                  <li
                    className={this.state.selectedTab == 'emergency' ? ' active' : ''}
                    onClick={() => this.tabBarClick('emergency')}
                  >
                    <a>Roadside Assistance</a>
                  </li>
                  <li
                    className={this.state.selectedTab == 'manufactures' ? ' active' : ''}
                    onClick={() => this.tabBarClick('manufactures')}
                  >
                    <a>supported manufactures</a>
                  </li>
                </div>
                <div className="nav-selector nav-selector-mobile">
                  <Slider {...settings} ref={c => this.slider = c}>
                    <li
                      className={this.state.selectedTab == 'car-wash' ? ' active' : ''}
                      onClick={() => this.tabBarClick('car-wash')}
                    >
                      <a>Car Wash</a>
                    </li>
                    <li
                      className={this.state.selectedTab == 'car-service' ? ' active' : ''}
                      onClick={() => {
                        this.tabBarClick('car-service');
                        this.slider.slickPrev();
                      }}
                    >
                      <a>Car service</a>
                    </li>
                    <li
                      className={this.state.selectedTab == 'car-repair' ? ' active' : ''}
                      onClick={() => this.tabBarClick('car-repair')}
                    >
                      <a>car repair</a>
                    </li>
                    <li
                      className={this.state.selectedTab == 'emergency' ? ' active' : ''}
                      onClick={() => {
                        this.tabBarClick('emergency');
                        this.slider.slickNext();
                      }}
                    >
                      <a>Roadside Assistance</a>
                    </li>
                    <li
                      className={this.state.selectedTab == 'manufactures' ? ' active' : ''}
                      onClick={() => this.tabBarClick('manufactures')}
                    >
                      <a>supported manufactures</a>
                    </li>
                  </Slider>
                </div>
                <div className={this.state.selectedTab + ' s-content-holder'}>
                  <SelectionBox
                    ref={'carwash'}
                    serviceType={'carwash'}
                    vendorProfileReducer={vendorProfileReducer}
                    commonReducer={commonReducer}
                    tabClickSwitch={this.tabClickSwitch.bind(this)}
                    hide={this.state.selectedTab != 'car-wash'}
                    buttonLabel={
                      authData &&
                        authData.isBusinessRegistered &&
                        authData.isGarageProfileCompleted &&
                        authData.isGarageServiceSelected
                        ? 'Save'
                        : 'Next'
                    }
                    isLoaded={this.state.isLoaded}
                    actions={actions}
                    serviceData={vendorProfileReducer.garageWashTypes}
                    topLevelServiceData={vendorProfileReducer.washTSD}
                    btnCallBack={() => this.handleBtnClick()}
                  />
                  <CustomPanelGroup
                    ref={'carservice'}
                    serviceType={'carservice'}
                    vendorProfileReducer={vendorProfileReducer}
                    commonReducer={commonReducer}
                    tabClickSwitch={this.tabClickSwitch.bind(this)}
                    hide={this.state.selectedTab != 'car-service'}
                    buttonLabel={
                      authData &&
                        authData.isBusinessRegistered &&
                        authData.isGarageProfileCompleted &&
                        authData.isGarageServiceSelected
                        ? 'Save'
                        : 'Next'
                    }
                    isLoaded={this.state.isLoaded}
                    actions={actions}
                    serviceData={this.state.serviceInfoList}
                    topLevelServiceData={vendorProfileReducer.servicingTSD}
                    btnCallBack={() => this.handleBtnClick()}
                  />
                  <CustomPanelGroup
                    ref={'carrepair'}
                    serviceType={'carrepair'}
                    vendorProfileReducer={vendorProfileReducer}
                    commonReducer={commonReducer}
                    tabClickSwitch={this.tabClickSwitch.bind(this)}
                    hide={this.state.selectedTab != 'car-repair'}
                    buttonLabel={
                      authData &&
                        authData.isBusinessRegistered &&
                        authData.isGarageProfileCompleted &&
                        authData.isGarageServiceSelected
                        ? 'Save'
                        : 'Next'
                    }
                    isLoaded={this.state.isLoaded}
                    actions={actions}
                    serviceData={vendorProfileReducer.garageRepairTypes}
                    topLevelServiceData={vendorProfileReducer.repairTSD}
                    parentServiceData={vendorProfileReducer.garageRepairParentTypes}
                    btnCallBack={() => this.handleBtnClick()}
                  />
                  <SelectionBox
                    ref={'emergency'}
                    serviceType={'emergency'}
                    vendorProfileReducer={vendorProfileReducer}
                    isEmergencyServices={true}
                    commonReducer={commonReducer}
                    tabClickSwitch={this.tabClickSwitch.bind(this)}
                    hide={this.state.selectedTab != 'emergency'}
                    buttonLabel={
                      authData &&
                        authData.isBusinessRegistered &&
                        authData.isGarageProfileCompleted &&
                        authData.isGarageServiceSelected
                        ? 'Save'
                        : 'Next'
                    }
                    isLoaded={this.state.isLoaded}
                    actions={actions}
                    topLevelServiceData={vendorProfileReducer.emergencyTSD}
                    serviceData={vendorProfileReducer.garageEmergencyTypes}
                    btnCallBack={() => this.handleBtnClick()}
                  />
                  <CheckboxGroup
                    ref={'manufactures'}
                    serviceType={'manufactures'}
                    vendorProfileReducer={vendorProfileReducer}
                    commonReducer={commonReducer}
                    tabClickSwitch={this.tabClickSwitch.bind(this)}
                    hide={this.state.selectedTab != 'manufactures'}
                    router={router}
                    buttonLabel={
                      authData &&
                        authData.isBusinessRegistered &&
                        authData.isGarageProfileCompleted &&
                        authData.isGarageServiceSelected
                        ? 'Save'
                        : 'Next'
                    }
                    isLoaded={this.state.isLoaded}
                    actions={actions}
                    data={vendorProfileReducer.garageManufacturers}
                    btnCallBack={() => this.handleBtnClick()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}

export default ManageServices;



// WEBPACK FOOTER //
// ./src/components/ManageServices/ManageServices.jsx